module.exports = __webpack_public_path__ + "static/media/orencash2.b57f203d.jpg";